export const CURRENT_USER_STORAGE_KEY: string = 'currentUser'